export const sceneParams: any = {
  groups: [
    {
      id: 'base',
      name: 'Scene settings',
    },
  ],
  parameters: [
    {
      id: 'stageType',
      name: 'Stage',
      type: 'picker',
      groupId: 'base',
      defaultValue: 'ground',
      options: ['ground', 'room'],
    },
    {
      id: 'stageSize',
      name: 'Size',
      type: 'picker',
      groupId: 'base',
      defaultValue: 'medium',
      options: ['small', 'medium', 'large'],
    },
  ],
};
